import { defineRecipe } from "@chakra-ui/react";

export default defineRecipe({
  base: {
    borderRadius: "l2",
    fontSize: "sm",
    fontWeight: "medium",
    gap: "2",
  },
  variants: {
    variant: {
      solid: {
        background: "gray.900",
        borderWidth: "0",
        boxShadow: "none",
        color: "white",

        _hover: {
          background: "gray.800",
          boxShadow: "none",
        },

        _active: {
          background: "gray.900",
        },
      },

      surface: {
        background: "white",
        boxShadow: "card",
        color: "fg",

        _hover: {
          background: "bg.subtle",
        },
      },

      danger: {
        background: "white",
        boxShadow: "card",
        color: "red.500",

        _hover: {
          background: "bg.subtle",
        },
      },

      destructive: {
        background: "red.500",
        borderWidth: "0",
        boxShadow: "none",
        color: "white",

        _hover: {
          background: "rgb(214,55,55)" as any,
        },
      },

      ghost: {
        background: "transparent",
        boxShadow: "none",
        color: "fg.muted",

        _hover: {
          background: "bg.hover",
          color: "fg",
        },
      },
    },

    size: {
      sm: {
        borderRadius: "l1",
        height: "8",
        minWidth: "8",
        paddingX: "2",
      },
      md: {
        height: "9",
        minWidth: "9",
        paddingX: "4",
      },
      lg: {
        height: "10",
        minWidth: "10",
        paddingX: "4",
      },
    },
  },
});
